import { render, staticRenderFns } from "./UiLink.vue?vue&type=template&id=37312e71&scoped=true"
import script from "./UiLink.vue?vue&type=script&lang=js"
export * from "./UiLink.vue?vue&type=script&lang=js"
import style0 from "./UiLink.vue?vue&type=style&index=0&id=37312e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37312e71",
  null
  
)

export default component.exports